export const SENTRY_IGNORE_ERRORS: Array<string | RegExp> = [
  'Unauthorized',
  /401/,
  /(bot\/bot)/,
  /Cannot read properties of null \(reading 'style'\)/,
  /Loading chunk \d+ failed/,
  /ChunkLoadError/,
  // Module Federation remote script load (CDN/network/deploy race) — not app bugs
  /Loading script failed/i,
  /while loading ["'].+["'] from \d+/i,
  // React / ApexCharts / extension DOM races — not actionable app bugs
  /Failed to execute 'removeChild' on 'Node'/i,
  /The node to be removed is not a child of this node/i,
  /Failed to execute 'insertBefore' on 'Node'/i,
  /li\.lms-analytics/,
  /require is not defined/,
  /chrome-extension:/i,
  /moz-extension:/i,
  /safari-extension:/i,
  /ResizeObserver loop (limit exceeded|completed)/i,
  /Non-Error promise rejection/i,
  /NetworkError when attempting to fetch/i,
  /^Script error\.?$/i,
  /AbortError/i,
  /cancelled/i,
  /botpress/i,
  /gtag|googletagmanager/i,
  /Failed to fetch dynamically imported module/i,
];

export const NOISE_IN_EVENT_PATTERNS: RegExp[] = [
  /chrome-extension:/i,
  /moz-extension:/i,
  /ResizeObserver loop/i,
  /Non-Error promise rejection/i,
  /^Script error\.?$/i,
  /li\.lms-analytics/i,
  /(bot\/bot)/i,
  /Loading script failed/i,
  /while loading ["'].+["'] from \d+/i,
  /Loading chunk \d+ failed/i,
  /ChunkLoadError/i,
  /Failed to fetch dynamically imported module/i,
  /Failed to execute 'removeChild' on 'Node'/i,
  /The node to be removed is not a child of this node/i,
  /Failed to execute 'insertBefore' on 'Node'/i,
];
